// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar{
    width: 300px;
    padding:0 20px ;
    padding-right: 10px;
    padding-top: var(--top-padding);
    height: 100vh;
    overflow-y: scroll;
}





.sidebar::-webkit-scrollbar {
    width: 0px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }


aside .side-head{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

aside .hide-responsive{
    display: none;
}

aside .side-head img {
    width: 60px;
}

aside .side-head p{
    font-weight: 700;
    font-size: 17px;
    margin:0px  2px;
}

aside > .title{
    color: var(--gray-color);
    font-size: 15px;
}

aside .all-tabs{
    padding-left: 5px;
    margin:0px 4px;

    margin-top: 10px;
    max-width: 100%;
}

aside .all-tabs .tab{
    width: 200px;
    margin-bottom: 15px;
    max-width: 100%;
}

aside .all-tabs .tab .top {
    cursor: pointer;
    width: 100%;
}

aside .all-tabs .tab .top .cont{
    display: flex;
    justify-content: space-between;
    border-radius: 13px;
    padding: 7px;
    max-width: 100%;
    transition: var(--main-transition);
}

aside .all-tabs .tab .active .top .cont {
    background-color: var(--main-color);
}

aside .all-tabs .tab .top .cont .left{
    display: flex;
    align-items: center;
}

aside .all-tabs .tab .top .cont .left .tab-log{
    background-color: white;
    width: 30px;
    height: 30px;
    border-radius: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #fafafa;
}

aside .all-tabs .tab .top .cont .left .tab-log svg{
    color: var(--main-color);
    font-size: 10px;
}

aside .all-tabs .tab .top .cont .left p{
    margin: 0px 8px;
    color: black;
    font-size: 14px;
    font-weight: 600;
}

aside .all-tabs .tab .active .top .cont .left p{
    margin-left: 12px;
    color: white;

}

aside .all-tabs .tab .top .cont .right svg{
    color: #717171;
    font-size: 10px;
    transition: var(--main-transition);
}

aside .all-tabs .tab .top .cont .right .arrow-opened{
transform: rotate(90deg);
}

aside .all-tabs .tab .top .cont .right .arrow-opened-ar{
    transform: rotate(-90deg);
    }




aside .all-tabs .tab .bottom{
    padding-top: 0px;
    display: flex;
    padding-left: 22px;
    align-items: center;
    transition: .3s;
    width: 0;
    opacity: 0;
    display: none;
}

aside .all-tabs .tab .show-bottom{
    
    display: flex;
    width: 100%;
    animation-name: showBottomAnimation;
    animation-delay: .4;
    animation-fill-mode: forwards;

    animation-duration: .4s;

}

aside .all-tabs .tab .bottom .line-tools{
    width: .9px;
    background-color: #EEE;
    height: 65px;
    margin:0px 22px;
}



aside .all-tabs .tab .bottom .sub-tabs .sub-tab{
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-bottom: 4px;
}

aside .all-tabs .tab .bottom .sub-tabs .sub-tab .icon svg{
color:var(--main-color) ;
font-size: 13px;
}

aside .all-tabs .tab .bottom .sub-tabs .sub-tab .sub-title{
    font-size: 13px;
    margin:0px 8px;
    height: 100%;
    color: var(--gray-color);
}

@keyframes showBottomAnimation {
    0% {
        padding-top: 0px;
        opacity: 0;
    }
    80%{
        padding-top: 5;
    }
    100% {
      opacity: 1;
      
    }
  }

  @media(max-width : 600px){
    .sidebar{
    position: fixed;
    background: white;
    width: 264px;
    border-right: 1px solid #EEE;
    z-index: 100;
    transition: .4s;
    } 

     .show-side{
        left: -100%;
        top: 0;
    }
    .hide-side{
        left: 0;
        top: 0;
    }

    [dir=rtl]{
        .hide-side{
            right: 0;
            top: 0;
        }
        .show-side{
        right: -100%;
        top: 0;
    }
    }
    aside .hide-responsive{
        display: block;
    }
    
    aside .side-head{
        justify-content: space-between;
    }

    aside .side-head .close-btn{
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #EEE;
        width: 24px;
        height: 24px;
        border-radius:50% ;
        border: none;
        cursor: pointer;
    }
    aside .side-head .close-btn svg{
        color: gray;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Utils/sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,kBAAkB;AACtB;;;;;;AAMA;IACI,UAAU;EACZ;;EAEA,UAAU;EACV;IACE,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;EAClB;;;AAGF;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;;IAEd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;;AAEhB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;AACA,wBAAwB;AACxB;;AAEA;IACI,yBAAyB;IACzB;;;;;AAKJ;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,UAAU;IACV,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,mCAAmC;IACnC,mBAAmB;IACnB,6BAA6B;;IAE7B,uBAAuB;;AAE3B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;AACA,wBAAwB;AACxB,eAAe;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,cAAc;IAClB;IACA;MACE,UAAU;;IAEZ;EACF;;EAEA;IACE;IACA,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf;;KAEC;QACG,WAAW;QACX,MAAM;IACV;IACA;QACI,OAAO;QACP,MAAM;IACV;;IAEA;QACI;YACI,QAAQ;YACR,MAAM;QACV;QACA;QACA,YAAY;QACZ,MAAM;IACV;IACA;IACA;QACI,cAAc;IAClB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":[".sidebar{\n    width: 300px;\n    padding:0 20px ;\n    padding-right: 10px;\n    padding-top: var(--top-padding);\n    height: 100vh;\n    overflow-y: scroll;\n}\n\n\n\n\n\n.sidebar::-webkit-scrollbar {\n    width: 0px;\n  }\n  \n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  \n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #888;\n  }\n  \n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #555;\n  }\n\n\naside .side-head{\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\naside .hide-responsive{\n    display: none;\n}\n\naside .side-head img {\n    width: 60px;\n}\n\naside .side-head p{\n    font-weight: 700;\n    font-size: 17px;\n    margin:0px  2px;\n}\n\naside > .title{\n    color: var(--gray-color);\n    font-size: 15px;\n}\n\naside .all-tabs{\n    padding-left: 5px;\n    margin:0px 4px;\n\n    margin-top: 10px;\n    max-width: 100%;\n}\n\naside .all-tabs .tab{\n    width: 200px;\n    margin-bottom: 15px;\n    max-width: 100%;\n}\n\naside .all-tabs .tab .top {\n    cursor: pointer;\n    width: 100%;\n}\n\naside .all-tabs .tab .top .cont{\n    display: flex;\n    justify-content: space-between;\n    border-radius: 13px;\n    padding: 7px;\n    max-width: 100%;\n    transition: var(--main-transition);\n}\n\naside .all-tabs .tab .active .top .cont {\n    background-color: var(--main-color);\n}\n\naside .all-tabs .tab .top .cont .left{\n    display: flex;\n    align-items: center;\n}\n\naside .all-tabs .tab .top .cont .left .tab-log{\n    background-color: white;\n    width: 30px;\n    height: 30px;\n    border-radius: 11px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 2px solid #fafafa;\n}\n\naside .all-tabs .tab .top .cont .left .tab-log svg{\n    color: var(--main-color);\n    font-size: 10px;\n}\n\naside .all-tabs .tab .top .cont .left p{\n    margin: 0px 8px;\n    color: black;\n    font-size: 14px;\n    font-weight: 600;\n}\n\naside .all-tabs .tab .active .top .cont .left p{\n    margin-left: 12px;\n    color: white;\n\n}\n\naside .all-tabs .tab .top .cont .right svg{\n    color: #717171;\n    font-size: 10px;\n    transition: var(--main-transition);\n}\n\naside .all-tabs .tab .top .cont .right .arrow-opened{\ntransform: rotate(90deg);\n}\n\naside .all-tabs .tab .top .cont .right .arrow-opened-ar{\n    transform: rotate(-90deg);\n    }\n\n\n\n\naside .all-tabs .tab .bottom{\n    padding-top: 0px;\n    display: flex;\n    padding-left: 22px;\n    align-items: center;\n    transition: .3s;\n    width: 0;\n    opacity: 0;\n    display: none;\n}\n\naside .all-tabs .tab .show-bottom{\n    \n    display: flex;\n    width: 100%;\n    animation-name: showBottomAnimation;\n    animation-delay: .4;\n    animation-fill-mode: forwards;\n\n    animation-duration: .4s;\n\n}\n\naside .all-tabs .tab .bottom .line-tools{\n    width: .9px;\n    background-color: #EEE;\n    height: 65px;\n    margin:0px 22px;\n}\n\n\n\naside .all-tabs .tab .bottom .sub-tabs .sub-tab{\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    margin-bottom: 4px;\n}\n\naside .all-tabs .tab .bottom .sub-tabs .sub-tab .icon svg{\ncolor:var(--main-color) ;\nfont-size: 13px;\n}\n\naside .all-tabs .tab .bottom .sub-tabs .sub-tab .sub-title{\n    font-size: 13px;\n    margin:0px 8px;\n    height: 100%;\n    color: var(--gray-color);\n}\n\n@keyframes showBottomAnimation {\n    0% {\n        padding-top: 0px;\n        opacity: 0;\n    }\n    80%{\n        padding-top: 5;\n    }\n    100% {\n      opacity: 1;\n      \n    }\n  }\n\n  @media(max-width : 600px){\n    .sidebar{\n    position: fixed;\n    background: white;\n    width: 264px;\n    border-right: 1px solid #EEE;\n    z-index: 100;\n    transition: .4s;\n    } \n\n     .show-side{\n        left: -100%;\n        top: 0;\n    }\n    .hide-side{\n        left: 0;\n        top: 0;\n    }\n\n    [dir=rtl]{\n        .hide-side{\n            right: 0;\n            top: 0;\n        }\n        .show-side{\n        right: -100%;\n        top: 0;\n    }\n    }\n    aside .hide-responsive{\n        display: block;\n    }\n    \n    aside .side-head{\n        justify-content: space-between;\n    }\n\n    aside .side-head .close-btn{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: #EEE;\n        width: 24px;\n        height: 24px;\n        border-radius:50% ;\n        border: none;\n        cursor: pointer;\n    }\n    aside .side-head .close-btn svg{\n        color: gray;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
